import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type LanguageEntityWithId = {
  idLanguageEntity: number;
};

// Типы для WebSocket сообщений компонента languageEntities
type LanguageEntityTranslationsMessage = WebSocketMessageWithFields<'language-entity-translations', {
  languageEntity: unknown;
}>;
type LanguageEntitiesListMessage = WebSocketMessageWithFields<'language-entity-list', {
  languageEntities: unknown[];
}>;
type LanguageEntityCreateMessage = WebSocketMessageWithFields<'language-entity-create' | 'language-entity-create-success', LanguageEntityWithId & {
  name: string;
}>;
type LanguageEntityDeleteMessage = WebSocketMessageWithFields<'language-entity-delete' | 'language-entity-delete-success', LanguageEntityWithId>;

// Объединенный тип для всех сообщений
type LanguageEntitiesWebSocketMessage = 
  | LanguageEntityTranslationsMessage 
  | LanguageEntitiesListMessage 
  | LanguageEntityCreateMessage 
  | LanguageEntityDeleteMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataLanguageEntities',
},
  __name: 'languageEntities',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID языковой сущности
const handleWebSocketMessage = (data: LanguageEntitiesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-entity-translations':
      store.dispatch('languageEntity/wsSetLanguageEntity', data.languageEntity);
      break;

    case 'language-entity-list':
      store.dispatch('languageEntities/wsSetLanguageEntities', { languageEntities: data.languageEntities });
      break;

    case 'language-entity-create':
    case 'language-entity-create-success':
      store.dispatch('languageEntities/wsLanguageEntityCreate', {
        idLanguageEntity: data.idLanguageEntity,
        name: data.name,
      });
      break;

    case 'language-entity-delete':
    case 'language-entity-delete-success':
      store.dispatch('languageEntities/wsLanguageEntityDelete', { idLanguageEntity: data.idLanguageEntity });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})